export default "__VITE_ASSET__e8ec6155__"